import { DateTime as DateTime$1 } from "../../../../components/DateTime/index.js";
import { EditFieldsByType } from "./components/EditFieldsByType.js";
import { useRef, useState } from "react";
import { Dropdown, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdEdit } from "react-icons/md";
//#region src/modules/Records/shared/EditableRecordField/index.tsx
function EditableRecordField({ canEdit, fieldName, fieldType = "text", onComplete, options, value }) {
	const [editMode, setEditMode] = useState(false);
	const containerRef = useRef(null);
	let valueDisplay = value;
	if (typeof value === "boolean") valueDisplay = value ? "Yes" : "No";
	else if (fieldType === "datetime" && typeof value === "string") valueDisplay = /* @__PURE__ */ jsx(DateTime$1, {
		timestamp: value,
		mode: "date",
		relative: false,
		toggleRelativeOnClick: false
	});
	const handleClose = () => {
		setEditMode(false);
	};
	const handleFieldClick = canEdit ? () => {
		if (fieldType === "boolean" && (typeof value === "boolean" || !value)) onComplete?.({
			fieldName,
			value: !value
		});
		else setEditMode(!editMode);
	} : void 0;
	return /* @__PURE__ */ jsxs("div", {
		ref: containerRef,
		children: [/* @__PURE__ */ jsxs("div", {
			className: classnames({ "hover:bg-neutral-faded cursor-pointer rounded transition-colors": canEdit }, "p-xs group flex min-h-10 items-center justify-between"),
			onClick: handleFieldClick,
			children: [/* @__PURE__ */ jsx("span", { children: valueDisplay }), canEdit && /* @__PURE__ */ jsx(Icon, {
				className: "ml-xs text-color-neutral-faded group-hover:text-color-semantic opacity-50 transition-colors",
				Icon: MdEdit,
				size: "xs"
			})]
		}), editMode && fieldType !== "boolean" && /* @__PURE__ */ jsx(Dropdown, {
			isOpen: true,
			onClose: handleClose,
			containerRef,
			dropdownInset: true,
			children: /* @__PURE__ */ jsx(EditFieldsByType, {
				name: fieldName,
				onCancel: handleClose,
				onComplete: (newValue) => {
					onComplete?.({
						fieldName,
						value: newValue
					});
					handleClose();
				},
				options,
				type: fieldType,
				value
			})
		})]
	});
}
//#endregion
export { EditableRecordField };

//# sourceMappingURL=index.js.map